import React, { lazy } from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import wkx from 'wkx';
import MapForm from '../../../../../MapForm';
import { Buffer } from 'buffer';

interface IProps extends ICellProps {
  isPolygon?: boolean
}

interface IState {
  isMapShowing: boolean;
}

const DataBlock = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  font-size: 12px;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  color: #003a72;
`;

class Trajectory extends React.Component<IProps> {
  state = {
    isMapShowing: false,
  };

  onShowEditDlg = (): void => {
    this.setState({ isMapShowing: true });
  };

  onCloseEditDlg = (): void => {
    this.setState({ isMapShowing: false });
  };

  onAccept = (data: any): void => {
    try {
      if (!this.props.isPolygon) {
        const coordinates = data.map((point: any) => [point.lon, point.lat]);
        if (coordinates.length > 2) {
          if (coordinates[0][0] !== coordinates[coordinates.length - 1][0] && coordinates[0][1] !== coordinates[coordinates.length - 1][1]) {
            coordinates.push(coordinates[0]);
          }
        }
        const json = {
        type: 'Polygon',
        coordinates:[coordinates]
        };
        const geom = wkx.Geometry.parseGeoJSON(json);
        this.props.onChange && this.props.onChange(geom.toEwkb().toString('hex'));
      } else {
        if (data?.coordinates) {
          this.props.onChange && this.props.onChange(data?.coordinates);
        }
      }
    } catch (e) {
      console.log('error', e);
    }

    this.setState({ isMapShowing: false });
  };

  getTrajectoryPoints = (): { lon: number; lat: number }[] => {
    let res: { lon: number; lat: number }[] = [];
    try {
      const wkbBuffer = new Buffer(this.props.value, 'hex');
      const geom = wkx.Geometry.parse(wkbBuffer);
      const json = geom.toGeoJSON() as any;
      if (json && json.coordinates && json.coordinates.length>0) {
        res = json.coordinates[0].map((el: [number, number]) => ({
          lat: el[1],
          lon: el[0],
        }));

        res.pop();
        console.log('res', res);
        return res;
      }
    } catch (e) {
      console.log(e);
    }
    return res;
  };

  render() {
    const { value } = this.props;
    return (
      <DataBlock onClick={this.onShowEditDlg}>
        {value?.length ? 'Заполнено' : 'Пусто'}&nbsp;
        <Icon iconName={'Edit'} />
        {this.state.isMapShowing && (
          <MapForm
            {...(this.props as any)}
            point={undefined}
            fillPolygon={true}
            trajectory={this.getTrajectoryPoints()}
            onClose={this.onCloseEditDlg}
            onAccept={this.onAccept}
          />
        )}
      </DataBlock>
    );
  }
}

export default Trajectory;
